import { Component } from '@angular/core';
import { Manufacturer } from 'src/app/models/manufacturer.model';
import { Router } from '@angular/router';
import { ManufacturersService } from 'src/app/services/manufacturers/manufacturers.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-manufacturer',
  templateUrl: './add-manufacturer.component.html',
  styleUrls: ['./add-manufacturer.component.scss'],
})
export class AddManufacturerComponent {
  [x: string]: any;
  constructor(
    private router: Router,
    private manufacturersService: ManufacturersService,
    private toastr: ToastrService
  ) {}
  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];

  dateNow: Date = new Date();
  NameError: boolean = false;
  addManufacturerRequest: Manufacturer = new Manufacturer();
  ngOnInit(): void {
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if (
      loggedInuserRole.role == 'Standard User' ||
      loggedInuserRole.role == 'Internal User' ||
      loggedInuserRole.role == 'Regional User'
    ) {
      this.logout();
    }
    this.addManufacturerRequest.Name = "";
  }

  validation() {
    let isValid = true;

    if (this.addManufacturerRequest.Name == "") {
      this.NameError = true;
      isValid = false;
    } else {
      this.NameError = false;
    }
    return isValid;
  }

  addManufacturer() {
    const dateNowISO = this.dateNow.toISOString();

    this.addManufacturerRequest.CreatedAt = dateNowISO;
    this.addManufacturerRequest.UpdatedAt = dateNowISO;
    if (this.validation()) {
      this.manufacturersService
        .addManufacturer(this.addManufacturerRequest)
        .subscribe({
          next: (manufacturer) => {
            var id = btoa(manufacturer.Id.toString());
            this.toastr.success(
              'Element Manufacturer Added Successfully.',
              'Information'
            );
            this.router.navigate(['/component/manufacturers/edit/' + id]);
          },
          error: (response) => {
            if (response.error.length > 0) {
              this.toastr.error(response.error, 'Error');
            } else {
              this.toastr.error('Error While Creating Element Manufacturer.', 'Error');
            }
          },
        });
    } else {
      this.toastr.error('Please validate all fields', 'Error');
    }
  }

  logout() {
    sessionStorage.clear();
    this.router.navigate(['login']);
  }
}
